export const buildUrlParams = (params ={}) => {
  const BUILD_PARAMS =  new URLSearchParams(params).toString() || null;
  const PARAMS = BUILD_PARAMS ? `&${BUILD_PARAMS}` : '';
  return PARAMS;
}